import { render, staticRenderFns } from "./StepsOptionsReview.vue?vue&type=template&id=660b63f3"
import script from "./StepsOptionsReview.vue?vue&type=script&lang=js"
export * from "./StepsOptionsReview.vue?vue&type=script&lang=js"
import style0 from "./StepsOptionsReview.vue?vue&type=style&index=0&id=660b63f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports